import { useQuery } from 'react-query';

import { Analytics } from '@components/pages/Organization/types';
import {
  ORGANIZATION_ANALYTICS_KEY,
  getOrganizationAnalytics,
} from '@utils/backend-api/organizations';

const useOrganizationAnalytics = (canViewAnalytics = true) => {
  return useQuery<Analytics>([ORGANIZATION_ANALYTICS_KEY], getOrganizationAnalytics, {
    staleTime: 10 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 2,
    enabled: canViewAnalytics,
  });
};

export default useOrganizationAnalytics;
